if (!window.__pdpCupomInit) {
  window.__pdpCupomInit = true;

  const RESET_MS = 2000;

  function fallbackCopy(text, done) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {
      /* sem clipboard disponível — feedback visual mesmo assim */
    }
    document.body.removeChild(ta);
    done();
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-cupom-copy]");
    if (!btn || btn.classList.contains("is-copied")) return;

    const code = btn.dataset.code;
    const chip = btn.querySelector("[data-cupom-chip]");
    const status = btn.querySelector("[data-cupom-status]");

    const done = () => {
      chip.textContent = "Copiado!";
      btn.classList.add("is-copied");
      if (status) status.textContent = "Cupom copiado para a área de transferência";
      window.clearTimeout(btn.__cupomTimer);
      btn.__cupomTimer = window.setTimeout(() => {
        btn.classList.remove("is-copied");
        chip.textContent = code;
        if (status) status.textContent = "";
      }, RESET_MS);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(done)
        .catch(() => fallbackCopy(code, done));
    } else {
      fallbackCopy(code, done);
    }
  });
}
